import React from "react";

import "./HomeWhyAcademy.css";

const reasons = [
  {
    title: "Production",
    text: "We have over 40 years' experience creating costumes for a wide variety of projects, ranging from private commissions to entire productions for film, television, theatre, music, fashion and commercials.",
    image: "/images/home/casino-royale.jpg",
  },
  {
    title: "Bespoke Tailoring",
    text: "High-end period and contemporary bespoke tailoring for film, theatre and private commissions.",
    image: "/images/home/bespoke-tailoring.jpg",
  },
  {
    title: "Textiles",
    text: "A large collection of vintage and contemporary suiting, shirting and other fabrics, available to purchase online or in person by appointment.",
    image: "/images/home/textiles.jpg",
  },
  {
    title: "Vintage Reproductions",
    text: "A new range of high-quality vintage reproduction clothing available in ready-to-wear or made-to-measure options.",
    image: "/images/home/vintage-reproductions.jpg",
  },
  {
    title: "Jewellery Rental",
    text: "A curated selection of costume jewellery, eyewear and timepieces available to hire for film, television, fashion editorials and selected private hires. For more information or appointments please contact andrew@academycostumes.co.uk",
    image: "/images/home/jewellery-rental.jpg",
  },
  {
    title: "Haberdashery",
    text: "A large selection of mostly vintage buttons, buckles, braids and assorted trimmings, available from our Waterloo Road shop or online.",
    image: "/images/home/haberdashery.jpg",
  },
  {
    title: "Buttons & Buttonholes",
    text: "Professional buttonholes, eyelets and button-covering services available at our Waterloo Road shop by appointment only.",
    image: "/images/home/buttons-buttonholes.jpg",
  },
  {
    title: "Millinery",
    text: "Specialist millinery and period headwear for costume, production and private commissions.",
    image: "/images/home/millinery.jpg",
  },
];

export default function HomeWhyAcademy() {
  return (
    <section className="home-why-academy" aria-labelledby="home-why-title">
      <div className="home-why-academy__header">
        <p className="home-why-academy__kicker">Why Academy Costumes London</p>

        <h2 id="home-why-title">Selected for detail, history and making.</h2>
      </div>

      <div className="home-why-academy__grid">
        {reasons.map((reason, index) => (
          <article className="home-why-academy__item" key={reason.title}>
            <div className="home-why-academy__image-wrap">
              <img
                src={reason.image}
                alt={reason.title}
                className="home-why-academy__image"
                loading="lazy"
                decoding="async"
              />
            </div>

            <div className="home-why-academy__item-content">
              <span className="home-why-academy__number">
                {String(index + 1).padStart(2, "0")}
              </span>

              <h3>{reason.title}</h3>

              <p>{reason.text}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
